import ReducerRegistry from '../base/redux/ReducerRegistry';
import { ADD_LIVE_TRANSLATION_LINE, CLEAR_LIVE_TRANSLATION, UPDATE_LAST_LIVE_TRANSLATION_LINE } from './actionTypes';
const DEFAULT_STATE = {
    lines: []
};
ReducerRegistry.register('features/live-translation', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case ADD_LIVE_TRANSLATION_LINE: {
            const normalize = (s) => (s || '')
                .trim()
                .toLowerCase()
                // remove trailing punctuation/symbols for better coalescing
                .replace(/[\p{P}\p{S}]+$/u, '');
            const incomingText = String(action.text || '');
            const normIncoming = normalize(incomingText);
            const incomingPid = action.participantId;
            const lines = [...state.lines];
            const lastIdx = (() => {
                if (!lines.length) {
                    return -1;
                }
                if (incomingPid) {
                    for (let i = lines.length - 1; i >= 0; i--) {
                        if (lines[i].participantId === incomingPid) {
                            return i;
                        }
                    }
                }
                return lines.length - 1;
            })();
            if (lastIdx >= 0) {
                const last = lines[lastIdx];
                const normLast = normalize(last.text);
                if (normIncoming === normLast || normIncoming.startsWith(normLast)) {
                    // Update last line instead of adding a duplicate
                    lines[lastIdx] = { ...last, text: incomingText, lang: action.lang, ts: Date.now() };
                    return { ...state, lines };
                }
            }
            return {
                ...state,
                lines: [...lines, { text: incomingText, lang: action.lang, participantId: incomingPid, ts: Date.now() }]
            };
        }
        case CLEAR_LIVE_TRANSLATION:
            return { ...state, lines: [] };
        case UPDATE_LAST_LIVE_TRANSLATION_LINE: {
            if (state.lines.length === 0) {
                return state;
            }
            const updated = [...state.lines];
            updated[updated.length - 1] = { ...updated[updated.length - 1], text: action.text, ts: Date.now() };
            return { ...state, lines: updated };
        }
        default:
            return state;
    }
});
